import { configureStore } from "@reduxjs/toolkit";
import roleSlice from "./Components/Redux/RoleSlice";
import tokenSlice from "./Components/Redux/TokenSlice";
import tabIndexSlice from "./Components/Redux/TabIndexSlice";
import resolutionSlice from "./Components/Redux/ResolutionSlice";
import cnsCommonSlice from "./Components/Redux/CNS/CommonSlice";
import cnsPAExtensionsSlice from "./Components/Redux/CNS/PAExtensionsSlice";
import cnsRejectedExtensionsSlice from "./Components/Redux/CNS/RejectedExtensionsSlice";
import cnsConfigurationsSlice from "./Components/Redux/CNS/ConfigurationsSlice";
import memberByPlanYearSlice from "./Components/Redux/MNR/MemberByPlanYearSlice";
import accessTokenSlice from "./Components/Redux/AccessTokenSlice";
import tableSlice from "./Components/Redux/TableSlice";
import MNRCommonSlice from "./Components/Redux/MNR/MNRCommonSlice";
import GroupByYearAllSlice from "./Components/Redux/MNR/GroupByYearAllSlice";
import DupeQASlice from "./Components/Redux/MNR/DupeQASlice";
import FormularySlice
    from "./Components/Redux/MNR/FormularySlice";
import PACompoundDetailSlice from "./Components/Redux/MNR/PACompoundDetailSlice";
import ReportsSecondTableSlice from "./Components/Redux/MNR/ReportsSecondTableSlice";
import ReportsTabSlice from "./Components/Redux/MNR/ReportsTabSlice";
import ReportsTabSecondTableSlice from "./Components/Redux/MNR/ReportsTabSecondTableSlice";
import PAPriceSlice from "./Components/Redux/MNR/PAPriceDetailSlice";
import CocaAnnualSlice from "./Components/Redux/MNR/CocaAnnualSlice";
import CocaAnnualTabSecondTableSlice from "./Components/Redux/MNR/CocaAnnualTabSecondTableSlice";
import PriorAuthSlice from "./Components/Redux/MNR/PriorAuthSlice";
import ProductDetailSlice from "./Components/Redux/MNR/ProductDetailSlice";
import CodeSetSlice from "./Components/Redux/MNR/CodeSetSlice";
import MMTCommonSlice from "./Components/Redux/MMTReports/MMTCommonSlice";
import CocaAnnualCommonSlice from "./Components/Redux/CocaAnnualReports/CocaAnnualCommonSlice";
import MMT3Slice from "./Components/Redux/MMTReports/MMT3Slice";
import MMT2Slice from "./Components/Redux/MMTReports/MMT2Slice";
import MMT1Slice from "./Components/Redux/MMTReports/MMT1Slice";
import ReportsCarrierSlice from "./Components/Redux/Reports/ReportsCarrierSlice";
import CocaCarrierSlice from "./Components/Redux/CocaAnnualReports/CocaCarrierSlice";
import MMTDataBricks from "./Components/Redux/DataBricks/MMTDataBricksSlice";
import CocaAnnual1 from "./Components/Redux/CocaAnnualReports/CocaAnnual1Slice";
import CocaAnnual2 from "./Components/Redux/CocaAnnualReports/CocaAnnual2Slice";
import CocaAnnual3 from "./Components/Redux/CocaAnnualReports/CocaAnnual3Slice";
import cocaDataBricksSlice from "./Components/Redux/DataBricks/CocaDataBricksSlice";

const store = configureStore(
    {
        reducer: {
            role: roleSlice,
            tab: tabIndexSlice,
            resolution: resolutionSlice,
            accessToken: accessTokenSlice,
            token: tokenSlice,
            table: tableSlice,
            cnsCommon: cnsCommonSlice,
            cnsPAExtensions: cnsPAExtensionsSlice,
            cnsRejectedExtensions: cnsRejectedExtensionsSlice,
            cnsConfigurations: cnsConfigurationsSlice,
            memberByPlanYear: memberByPlanYearSlice,
            mnrCommon: MNRCommonSlice,
            groupByYearAll: GroupByYearAllSlice,
            dupeQA: DupeQASlice,
            formulary: FormularySlice,
            paCompound: PACompoundDetailSlice,
            reportsSecondTable: ReportsSecondTableSlice,
            reportsTab: ReportsTabSlice,
            reportsTabSecondTable: ReportsTabSecondTableSlice,
            paPrice: PAPriceSlice,
            cocaAnnual: CocaAnnualSlice,
            cocaAnnualTabSecondTable: CocaAnnualTabSecondTableSlice,
            priorAuth: PriorAuthSlice,
            productDetail: ProductDetailSlice,
            codeSet: CodeSetSlice,
            mmtCommon: MMTCommonSlice,
            cocaAnnualCommon: CocaAnnualCommonSlice,
            mmt3: MMT3Slice,
            mmt2: MMT2Slice,
            mmt1: MMT1Slice,
            reportsCarrier: ReportsCarrierSlice,
            cocaCarrier: CocaCarrierSlice,
            mmtDataBricks: MMTDataBricks,
            cocaAnnual1: CocaAnnual1,
            cocaAnnual2: CocaAnnual2,
            cocaAnnual3: CocaAnnual3,
            cocaDataBricks: cocaDataBricksSlice,
        }
    }
)

export default store